module.exports = __webpack_public_path__ + "static/media/no-published.2388e581.png";